import React, { useState, useCallback } from 'react';
import { clinicService } from '../../../services/api';

const Step4_Confirm = ({ clinicId, mappings, onBack, onComplete, error, setError }) => {
  const [applying, setApplying] = useState(false);
  const [results, setResults] = useState(null);

  const handleApply = useCallback(async () => {
    const invalid = mappings.filter((m) => !m.service_provided?.trim());
    if (invalid.length > 0) {
      setError(`${invalid.length} doctor(s) have empty service_provided`);
      return;
    }
    setApplying(true);
    setError('');
    setResults(null);
    const success = [];
    const failed = [];
    for (const m of mappings) {
      try {
        await clinicService.updateClinicDoctor(clinicId, m.doctor.id, {
          service_provided: m.service_provided,
        });
        success.push(m.doctor.primary_name);
      } catch (err) {
        failed.push({
          name: m.doctor.primary_name,
          error: err.response?.data?.detail || err.message || 'Update failed',
        });
      }
    }
    setResults({ success, failed });
    setApplying(false);
    onComplete?.({ success: failed.length === 0, updated: success.length, failed: failed.length, clinicId });
  }, [clinicId, mappings, onComplete, setError]);

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 4: Confirm</h2>
        <p className="text-gray-600">
          Apply changes to {mappings.length} doctor{mappings.length !== 1 ? 's' : ''}?
        </p>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800">
          This will replace service_provided for each doctor listed above.
        </p>
      </div>

      {results && (
        <div className="space-y-2">
          {results.success.length > 0 && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="font-medium text-green-800">Updated: {results.success.join(', ')}</p>
            </div>
          )}
          {results.failed.length > 0 && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="font-medium text-red-800">Failed:</p>
              <ul className="list-disc list-inside text-sm text-red-700 mt-1">
                {results.failed.map((f, i) => (
                  <li key={i}>{f.name}: {f.error}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">{error}</div>
      )}

      <div className="flex justify-between">
        <button
          onClick={onBack}
          disabled={applying}
          className="px-6 py-3 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 font-medium disabled:opacity-50"
        >
          Back
        </button>
        <button
          onClick={handleApply}
          disabled={applying}
          className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        >
          {applying ? 'Updating...' : 'Apply Changes'}
        </button>
      </div>
    </div>
  );
};

export default Step4_Confirm;
